<div style="overflow: hidden; max-width: 100%; max-height: 100%;" >
  <video muted="true" autoplay="true" loop="loop" id="loginVideo" oncanplay="this.play()"
         onloadedmetadata="this.muted = true">
    <source id="srcvid" src="assets/videos/Render_me_V_1_4.mp4" type="video/mp4" />
    <source src="assets/videos/Render_me_V_1_6.webm" type="video/webm" />
  </video>
</div>
<div class="content">
  <div class="row " style="height: 100vh;">
    <div class="col-md-8">
    </div>
    <div class="col-md-3 d-flex flex-column align-items-center justify-content-center">
      <div class="login_side d-flex flex-column align-items-center justify-content-center">
        <h4 class="">Eco-Driving Platform         
          <img class="title-img" src="assets/icons/logo-title.svg" alt="" />
        </h4>
        <div class="row center mb-8">
          <img class="logo-img" src="assets/images/logo.png" alt="" />
        </div>
        <div>
        </div>
        <form class="example-form" color="red" action="#" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Nom d'utilisateur</mat-label>
            <input matInput  type="text" name="username" formControlName="username">
          </mat-form-field>
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Mot de passe</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password" name="password"
                   autocomplete />
            <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide">
              <mat-icon style="color: #262757;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
          <div class="row">
            <div class="w-100 d-flex flex-row align-items-center justify-content-center">
              <button type="submit" (click)="onSubmit(loginForm.value)" class="login-btn" *ngIf="loading == false"
                      mat-button>Connexion</button>
              <button type="button" (click)="onSubmit(loginForm.value)" *ngIf="loading == true" mat-button>
                <div role="status">
                  <span style="color: #262757; font-size: 15px;">Loading...</span>
                </div>
              </button>
            </div>
          </div>
          <br />
        </form>
        <h5>Copyright © 2020, Stg drive Tous droits réservés</h5>
      </div>
    </div>
    <div class="col-md-1">
    </div>
  </div>
  <span id="w-header-top-desactive"></span>
  <span id="w-header-top-active"></span>
</div>
